module.exports = __webpack_public_path__ + "img/Delete Icon - white.5aab788e.svg";